import React from "react";
import clsx from "clsx";

type RlNavigationSubmenuItemProps = {
  className?: string;
  children: React.ReactNode;
  noLink?: boolean;
};

const RlNavigationSubmenuItem = ({
  className,
  children,
  noLink
}: RlNavigationSubmenuItemProps) => (
  <div
    className={clsx(
      "main-nav__submenu-item",
      className,
      noLink && "main-nav__submenu-item--noLink"
    )}
    data-testid="main_nav_submenu_item"
  >
    {children}
  </div>
);

export default RlNavigationSubmenuItem;
